__turbopack_context__.v({
  "action": "_4D_vkW_action",
  "card": "_4D_vkW_card",
  "content": "_4D_vkW_content",
  "textItem": "_4D_vkW_textItem",
});
